<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="toc" epub:type="toc" role="doc-toc">
<header><h1 class="h1" id="toc"><span aria-label=" Page vii. " epub:type="pagebreak" id="page_vii" role="doc-pagebreak">Contents</span></h1></header>
<p class="toc"><a href="#/xhtml/preface">Preface</a></p>
<p class="toc"><a href="#/xhtml/ack">Acknowledgments</a></p>
<p class="toc"><a href="#/xhtml/intro">Introduction</a></p>
<p class="toc1"><a href="#/xhtml/ch01">1. What Controls the Earth’s Climate?</a></p>
<p class="toc1"><span href="#/xhtml/ch02" title="Link target outside of Sample">2. A Slowly Warming Sun</span></p>
<p class="toc1"><span href="#/xhtml/ch03" title="Link target outside of Sample">3. Sliding Plates and Colliding Continents</span></p>
<p class="toc1"><span href="#/xhtml/ch04" title="Link target outside of Sample">4. Cooling and Warming from Volcanic Eruptions</span></p>
<p class="toc1"><span href="#/xhtml/ch05" title="Link target outside of Sample">5. Earth’s Orbital Variations</span></p>
<p class="toc1"><span href="#/xhtml/ch06" title="Link target outside of Sample">6. Moving Heat with Ocean Currents</span></p>
<p class="toc1"><span href="#/xhtml/ch07" title="Link target outside of Sample">7. Short-term Solar Variations</span></p>
<p class="toc1"><span href="#/xhtml/ch08" title="Link target outside of Sample">8. Catastrophic Collisions</span></p>
<p class="toc1"><span href="#/xhtml/ch09" title="Link target outside of Sample">9. A Plague of Humans</span></p>
<p class="toc2"><span href="#/xhtml/ch10" title="Link target outside of Sample">10. Tipping Points</span></p>
<p class="toc2"><span href="#/xhtml/ch11" title="Link target outside of Sample">11. What Now?</span></p>
<p class="toc"><span href="#/xhtml/notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/xhtml/index" title="Link target outside of Sample">Index</span></p>
<p class="toc"><span href="#/xhtml/author" title="Link target outside of Sample">About the Author</span></p>
<p class="toc"><span href="#/xhtml/bm02" title="Link target outside of Sample">About New Society Publishers<span aria-label=" Page viii. " epub:type="pagebreak" id="page_viii" role="doc-pagebreak"></span></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?07e11b9c